import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'muni-shared-checkbox-option',
  templateUrl: './checkbox-option.component.html',
  styleUrls: ['./checkbox-option.component.scss']
})
export class CheckboxOptionComponent {
  @Input()
  public name: string;

  @Input()
  public checked: boolean;

  @Input()
  public disabled: boolean;

  @Output()
  public changed: EventEmitter<HTMLInputElement> = new EventEmitter<HTMLInputElement>();

  public onChecked(event: Event) {
    this.changed.emit(event.target as HTMLInputElement);
  }
}
